import { Api } from "@core/api/api";
import { ReportDraft } from "@domain/report/report";
import { FeatureType } from "./supportService";

const SUPPORT_URL = "/support";

export class SupportApi {
	constructor(private readonly api: Api) {}

	async requestFeature(type: FeatureType): Promise<void> {
		return this.api.post(`${SUPPORT_URL}/request-feature?type=${type}`);
	}

	report(report: ReportDraft): Promise<void> {
		return this.api.post(`${SUPPORT_URL}/report-abuse`, report);
	}
}
